import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

// This should be a secure, randomly generated key stored securely (e.g., in environment variables)
const SECRET_KEY =  'cookiePDev';

const cookieUtils = {
  setSecureCookie: (name, value, options = {}) => {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    Cookies.set(name, encryptedValue, {
      ...options,
      secure: false,
      sameSite: 'strict'
    });
  },

  getSecureCookie: (name) => {
    const encryptedValue = Cookies.get(name);
    if (encryptedValue) {
      try {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
        const decryptedValue = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        return decryptedValue;
      } catch (error) {
        console.error('Error decrypting cookie:', error);
        return null;
      }
    }
    return null;
  },

  removeSecureCookie: (name) => {
    Cookies.remove(name);
  }
};

export default cookieUtils;